import { PlanningEventGeneratedEntity } from "./generated/PlanningEventGeneratedEntity";

export enum PlanningEventState {
    NotStarted = "NotStarted",
    InProgress = "InProgress",
    Overdue = "Overdue",
    Completed = "Completed",
}

export abstract class PlanningEventEntity extends PlanningEventGeneratedEntity {
    // Comment to preserve new line

    get isMilestone(): boolean {
        return this.endDate === null;
    }

    get status(): PlanningEventState | null {
        if (this.isMilestone) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            const milestoneDate = this.startDate;
            if (milestoneDate && milestoneDate.getTime() < today.getTime()) {
                return PlanningEventState.Completed;
            }
            return null;
        }
        const progress = this.progress ?? 0;

        if (progress >= 100) {
            return PlanningEventState.Completed;
        }

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const dueDate = this.endDate;
        if (dueDate && dueDate.getTime() < today.getTime()) {
            return PlanningEventState.Overdue;
        }

        if (progress > 0) {
            return PlanningEventState.InProgress;
        }

        return PlanningEventState.NotStarted;
    }
}
